import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredSearchFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.304 2.68C4.752 2.68 2.688 4.752 2.688 7.296C2.688 9.84 4.76 11.912 7.304 11.912C8.552 11.912 9.68 11.416 10.512 10.616C10.528 10.592 10.552 10.568 10.568 10.552C10.592 10.528 10.608 10.512 10.632 10.496C11.432 9.664 11.928 8.536 11.928 7.288C11.928 4.736 9.856 2.672 7.312 2.672L7.304 2.68ZM12.224 11.232C13.088 10.152 13.6 8.784 13.6 7.296C13.6 3.824 10.776 1 7.304 1C3.832 1 1 3.824 1 7.304C1 10.784 3.824 13.608 7.304 13.608C8.792 13.608 10.16 13.096 11.24 12.232L13.816 14.808C14.088 15.08 14.536 15.08 14.808 14.808C15.08 14.536 15.08 14.088 14.808 13.816L12.232 11.24L12.224 11.232Z"
      fill="black"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColouredSearchFilled)
const IconSvgColouredSearchFilled = createIcon(
  ForwardRef,
  'SvgColouredSearchFilled',
)
export default IconSvgColouredSearchFilled
